// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { StoresInstance } from "Globals/Stores";

// Dto
import { CreditReportDTO } from "Globals/Models/DTO/CreditReportDTO";
import { CreditReportModel } from "./CreditReportModel";

export class ParentCreditReportModel extends ModelBase<ParentCreditReportModel> {
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public reportsRequired: boolean = false;

    @MobX.observable public creditReportModels: CreditReportModel[] = [];

    @MobX.action
    public fromDto = (model: CreditReportDTO[]): void => {
        if (model !== null && model !== undefined) {
            model.forEach((creditReport) => {
                let localCreditReportModels: CreditReportModel = new CreditReportModel();
                localCreditReportModels.fromDto(creditReport);
                this.creditReportModels.push(localCreditReportModels);
            });
        }
    };
    @MobX.action
    public toDto = (): boolean => {
        return true;
    };
}
